import React, { useState, useEffect } from 'react'

import { QueryClient, QueryClientProvider } from 'react-query'
import { useNavigate } from 'react-router'
import { TbArrowBackUp } from 'react-icons/tb'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
const NowItem = (props) => {
  const { date, comment } = props
  return (
    <div className={'item'}>
      <h3 style={{ marginTop: 0 }}>{date}</h3>
      <p className={'description'}>{comment}</p>
    </div>
  )
}
NowItem.propTypes = {
  date: PropTypes.string,
  comment: PropTypes.string,
}

const Now = () => {
  const queryClient = new QueryClient()
  const [data, setData] = useState([])
  const location = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetch('/api/now.json')
      if (!data.ok) {
        throw new Error(`Now API is not working ${data.statusText}`)
      }
      return data.json()
    }
    fetchData().then((data) => {
      setData(data)
    })
  }, [])

  const handleBack = () => {
    if (location.state?.fromHome) {
      window.history.back()
    } else {
      navigate('/')
    }
  }
  return (
    <QueryClientProvider client={queryClient}>
      <section className={'archive-item'}>
        {data?.map((comment, index) => {
          const date = index === 0 ? 'NOW' : comment.date
          return (
            <NowItem key={comment.id} date={date} comment={comment.comment} />
          )
        })}
      </section>
      <button className="floating-back-btn" onClick={handleBack}>
        <TbArrowBackUp />
      </button>
    </QueryClientProvider>
  )
}

export default Now
